<template>
  <div v-if="show">
    <vs-alert
      v-if="$validator.errors.all().length > 0 || showError"
      color="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      <ul>
        <li
          class="mb-2"
          v-for="error in $validator.errors.all()"
          :key="error.id"
        >
          {{ error }}
        </li>

        <li class="mb-2" v-if="showError">
          {{ messageError }}
        </li>
      </ul>
    </vs-alert>

    <form ref="form" role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row mb-4">
        <!-- Nome Recebedor -->
        <div class="vx-col w-1/2">
          <vs-input
            :disabled="editModePagarme"
            class="w-full"
            label-placeholder="Nome Recebedor"
            name="Nome Recebedor"
            id="Nome Recebedor"
            v-model="form.nomeRecebedor"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Recebedor'
              )
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Nome Recebedor'
              )
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>

        <!-- Porcentagem -->
        <div class="vx-col w-1/2">
          <vs-input
            type="number"
            max="100"
            min="1"
            class="w-full"
            label-placeholder="Porcentagem (%)"
            name="Porcentagem"
            id="Porcentagem"
            v-model="form.porcentagem"
            v-validate="{ required: true, max_value: 100 }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Porcentagem'
              )
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Porcentagem'
              )
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <!-- Dados Pagar.me -->
      <div>
        <div class="vx-row mb-4">
          <!-- Tipo Pessoa -->
          <div class="vx-col w-1/2 flex flex-col">
            <span class="label mb-2">Tipo Pessoa</span>
            <div>
              <vs-radio
                :disabled="editModePagarme"
                v-model="form.dadosPagarme.type"
                vs-value="individual"
                class="mr-4"
              >
                Física
              </vs-radio>
              <vs-radio
                :disabled="editModePagarme"
                v-model="form.dadosPagarme.type"
                vs-value="company"
              >
                Jurídica
              </vs-radio>
            </div>
          </div>

          <!-- CPF/CNPJ -->
          <div class="vx-col w-1/2">
            <vs-input
              :disabled="editModePagarme"
              class="w-full"
              label-placeholder="CPF/CNPJ"
              name="CPF/CNPJ"
              id="CPF/CNPJ"
              v-model="form.dadosPagarme.document"
              v-validate="{ required: true }"
              v-mask="maskCPFCNPJ"
              :state="
                utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'CPF/CNPJ'
                )
              "
              :class="
                utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'CPF/CNPJ'
                )
              "
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>

        <vs-divider />

        <div class="vx-row mb-4">
          <!-- Tipo Conta -->
          <div class="vx-col w-1/2 flex flex-col">
            <span class="label mb-2">Tipo Conta</span>
            <div>
              <vs-radio
                v-model="form.dadosPagarme.default_bank_account.type"
                vs-value="checking"
                class="mr-4"
              >
                Conta Corrente
              </vs-radio>
              <vs-radio
                v-model="form.dadosPagarme.default_bank_account.type"
                vs-value="savings"
              >
                Poupança
              </vs-radio>
            </div>
          </div>
        </div>

        <div class="vx-row mb-4">
          <!-- Banco -->
          <div class="vx-col w-1/2">
            <vs-input
              class="w-full"
              label-placeholder="Banco"
              name="Banco"
              id="Banco"
              v-model="form.dadosPagarme.default_bank_account.bank"
              v-validate="{ required: true }"
              :state="
                utilsList.validateState(this.veeFields, this.veeErrors, 'Banco')
              "
              :class="
                utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Banco'
                )
              "
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>

          <!-- Agencia -->
          <div class="vx-col w-1/2">
            <vs-input
              class="w-full"
              label-placeholder="Agencia"
              name="Agencia"
              id="Agencia"
              v-model="form.dadosPagarme.default_bank_account.branch_number"
              v-validate="{ required: true }"
              :state="
                utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'Agencia'
                )
              "
              :class="
                utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Agencia'
                )
              "
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>

        <div class="vx-row mb-4">
          <!-- Número da conta -->
          <div class="vx-col w-1/2">
            <vs-input
              class="w-full"
              label-placeholder="Número da conta"
              name="Número da conta"
              id="Número da conta"
              v-model="form.dadosPagarme.default_bank_account.account_number"
              v-validate="{ required: true }"
              :state="
                utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'Número da conta'
                )
              "
              :class="
                utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Número da conta'
                )
              "
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>

          <!-- Digito Conta -->
          <div class="vx-col w-1/2">
            <vs-input
              class="w-full"
              label-placeholder="Digito Conta"
              name="Digito Conta"
              id="Digito Conta"
              v-model="
                form.dadosPagarme.default_bank_account.account_check_digit
              "
              v-validate="{ required: true }"
              :state="
                utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'Digito Conta'
                )
              "
              :class="
                utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Digito Conta'
                )
              "
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <vs-checkbox v-model="form.principal">
            Recebedor Principal
          </vs-checkbox>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full text-right mt-5">
          <BotaoSubmit
            variant="success"
            :edit="true"
            :aguarde="aguardeCadastro"
            reference="BtnEditar"
          ></BotaoSubmit>
        </div>
      </div>
    </form>

    <div class="vx-row" v-if="errorApi">
      <div class="vx-col w-full">
        <span>Falha na comunicação com Pagar.me</span>
        <pre v-html="errorApi"></pre>
      </div>
    </div>
  </div>
</template>

<script>
import BotaoSubmit from "./../../../../components/BotaoSubmit";
import cpfCnpj from "./../../../../services/cpfCnpj";
import service from "../../../../services";
import utilsList from "./../../../../utils/list";

const baseForm = {
  idRecebedor: null,
  idEmpresa: null,
  idCarteira: null,
  nomeRecebedor: null,
  porcentagem: null,
  idExterno: null,
  principal: false,
  dadosPagarme: {
    document: null,
    type: "company",
    default_bank_account: {
      holder_name: null,
      bank: null,
      branch_number: null,
      account_number: null,
      account_check_digit: null,
      holder_type: null,
      holder_document: null,
      type: "checking",
    },
  },
};

export default {
  props: ["dataRecebedor"],
  components: {
    BotaoSubmit,
  },
  watch: {
    dataRecebedor(value) {
      this.reset();
      this.$validator.pause();

      const resetForm = JSON.parse(JSON.stringify(baseForm));
      this.form = { ...resetForm, ...value };

      this.editMode = !this.form.idRecebedor ? false : true;
      this.editModePagarme = !this.form.idExterno ? false : true;

      this.$validator.reset();
      this.$nextTick(() => {
        this.$validator.resume();
        this.show = true;
      });
    },
  },
  data() {
    return {
      utilsList,
      aguardeCadastro: false,
      showError: false,
      messageError: null,
      editModePagarme: false,
      editMode: false,
      show: false,
      errorApi: null,
      form: { ...Object.freeze(baseForm) },
    };
  },
  methods: {
    async onSubmit() {
      try {
        const validated = await this.$validator.validateAll();
        if (!validated) {
          return;
        }

        if (!cpfCnpj.valida_cpf_cnpj(this.form.dadosPagarme.document)) {
          this.showError = true;
          this.messageError = "CPF/CNPJ inválido";
          return;
        }

        this.$vs.loading();
        this.errorApi = null;
        this.aguardeCadastro = true;

        const { idRecebedor } = this.form;
        const action = !this.editMode
          ? "Adicionar"
          : `Atualizar/${idRecebedor}`;

        await service.post("CarteiraCobranca/Recebedores", action, this.form);

        this.$emit("savedRecebedor");
      } catch (error) {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Falha ao salvar o recebedor",
          color: "danger",
        });

        if (error.indexOf("{") >= 0) {
          this.errorApi = JSON.stringify(JSON.parse(error), null, 2)
            .replace(" ", "&nbsp;")
            .replace("\n", "<br/>");
        }
      } finally {
        this.aguardeCadastro = false;
        this.$vs.loading.close();
      }
    },
    reset() {
      this.show = false;
      this.showError = false;
      this.messageError = null;
      this.errorApi = null;
    },
  },
  computed: {
    maskCPFCNPJ() {
      if (this.form.dadosPagarme.type == "individual") {
        return "###.###.###-##";
      }

      return "##.###.###/####-##";
    },
  },
};
</script>

<style>
.label {
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.4);
}

pre {
  background-color: black;
  padding: 0.8rem;
  font-size: 0.7rem;
  font-family: monospace;
  white-space: pre-wrap;
  color: #72e0d1;
}
</style>
